import React, { useState, useEffect } from "react";

const NetworkConnection = (props) => {
  // state variable holds the state of the internet connection
  const [isOnline, setOnline] = useState(true);

  // On initization set the isOnline state.
  useEffect(() => {
    setOnline(navigator.onLine);
  }, []);

  // event listeners to update the state
  window.addEventListener("online", () => {
    setOnline(true);
  });

  window.addEventListener("offline", () => {
    setOnline(false);
  });

  // if user is online, return the child component else return a custom component
  if (isOnline) {
    return props.children;
  } else {
    return (
      <div style={{gridColumn:"1",
                   gridRow:"1",
                   placeSelf:"center"}}>
        <h1>لا يوجد اتصال</h1>
        <h2> الرجاء فحص شريط التوصيل...</h2>
      </div>
    );
  }
};

export default NetworkConnection;
